import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { environment } from '../../../../environments/environment.prod';
import { Observable, Observer, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PlatformUserService {
  httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  baseUrl: string = environment.backend;

  constructor(private http: HttpClient) { }

  loginUser(userData: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/authenticate/', userData, { headers: this.httpHeaders });
  }
  ssoUser(userData: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/authenticate-sso/', userData, {
      headers: this.httpHeaders,
    });
  }
  createOnline$() {
    return merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }
}
